module.exports = __webpack_public_path__ + "01_bob_black.762714ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/01_bob_black.png
// module id = jLJ/
// module chunks = 0